import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {lang} from 'js/Core/lang';
import DatePicker, {registerLocale} from 'react-datepicker';
import {customFormatDate} from '../Core/date';
import ja from "date-fns/locale/ja";
import {storeInfoUser} from '../Core/utils';
import FormNote from '../Components/FormNote';
registerLocale('ja', ja);
ja.options.weekStartsOn = 0;

const txtLang = lang.txt;
const mapStateToProps = state => {
	return {
		errors : state.errors,
		fieldsDefination: state.fieldsDefination,
		person: state.person,
		shop: state.shop
	}
}

const mapDispatchToProps = dispatch => {
	return {
	
	}
}

const listCheckBoxRequest = ['スーツ','ジャケット','パンツ','シャツ','フォーマル','コート','靴','ジーンズ','その他'];
const listSelectSex = ['女性','男性'];
const listSelectAge = ['10代','20代','30代','40代','50代','60代','70代以降'];
const listMinTimeOnWeek = ['10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00'];
const listMaxTimeOnWeek = ['10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00'];
const listMinTimeWeekend = ['10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00'];
const listMaxTimeWeekend = ['10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00'];
const listSelectAdv = ['ポストチラシ','検索エンジン','バナー広告','インスタグラム','Facebook','ホットペッパー','お友達のご紹介','社員紹介','その他','【沖縄エリア】','まかせてクーポン']
const listSelectShop = ['射水本店','富山二口店'];
const listSelectOrder = ['ある','ない'];

class FormInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			customerName: '',
			fullName: '',
			phoneNumber: '',
			email: '',
			birthDate: '',
			sex: '女性',
			age: '',
			advSelect :'', 
			isShowAdvFriend: false,
			advFriend: '',
			selectAge: '', 
			minTimeOnWeek: '', 
			maxTimeOnWeek: '',
			minTimeWeekend: '',
			maxTimeWeekend: '',
			listShops: '',
			listRequestItems: [], 
			listOrders: '', 
			listSize: {
				height: '',
				width: '',
				weight: ''
			},
			message: ''
		};		
		['handleChange','handleSelectDate','handleChangeRequest','setInfoData','handleChangeSize','handleChangeAdv'].forEach(fn => this[fn] = this[fn].bind(this));
	}	
	componentDidMount(){
		let {person} = this.props,
			infoData = storeInfoUser(person);			
		if(Object.entries(infoData).length > 0){
			let {customerName, fullName, phoneNumber, email, birthDate,sex, age, minTimeOnWeek, 
				maxTimeOnWeek, minTimeWeekend, maxTimeWeekend, selectAge, advSelect, message, 
				advFriend, listShops, listRequestItems, listOrders, listSize} = infoData;			
			this.setState({
				customerName: customerName || '', 
				fullName: fullName || '', 
				phoneNumber: phoneNumber || '', 
				email: email || '', 
				birthDate: birthDate || '',
				sex: sex || '女性',
				age: age || '',
				advSelect : advSelect || '',
				advFriend: advFriend || '',
				isShowAdvFriend: advSelect === 'お友達のご紹介',
				selectAge: selectAge || '',
				minTimeOnWeek: minTimeOnWeek || '',
				maxTimeOnWeek: maxTimeOnWeek || '',
				minTimeWeekend: minTimeWeekend || '',
				maxTimeWeekend: maxTimeWeekend || '',
				listShops: listShops || '',
				listRequestItems: listRequestItems || [], 
				listOrders: listOrders || '', 
				listSize: listSize || {
					height: '',
					width: '',
					weight: ''
				},
				message: message || ''
			})
		}	
	}	
	setInfoData(name, value){
		let infoData = localStorage.getItem('infoData') ? JSON.parse(localStorage.getItem('infoData')) : null;
		if(infoData){
			infoData[name] = value;
			localStorage.setItem('infoData', JSON.stringify(infoData));
		}else{
			localStorage.setItem('infoData',JSON.stringify({[name]: value}));
		}
	}
	handleChange(e){
		let {name, value} = e.target;
		this.setInfoData(name,value);
		this.setState({
			[name]: value
		})
	}
	handleChangeAdv(e){
		let {value} = e.target;
		this.setInfoData('advSelect', value);
		this.setState({
			advSelect: value,
			isShowAdvFriend: value === 'お友達のご紹介' 
		})
	}
	handleSelectDate(value){
		let date = value ? customFormatDate(value) : '';
		this.setInfoData('birthDate', date);
		this.setState({
			birthDate: value
		})
	}
	handleChangeRequest(value){
		let {listRequestItems} = this.state,
			newList = [];
		if(listRequestItems.includes(value)) newList = [...listRequestItems].filter(item => item !== value);
		else newList = [...listRequestItems, value];
		this.setInfoData('listRequestItems', newList);
		this.setState({
			listRequestItems: newList
		})
	}
	handleChangeSize(e){
		let {name, value} = e.target,
			{listSize} = this.state,
			newListSize = {...listSize, [name]: value.replace(/\D/ig,'')};	// value.replace(/\+|-|\,|\D/ig,'')
		this.setInfoData('listSize', newListSize);
		this.setState({listSize: newListSize});
	}
	handleKeyUp(e){
		if(e.keyCode === 13){
			e.target.blur();
		}
	}
	clearDatePicker(){
		let {birthDate} = this.state,
			{datepicker} = this.refs;
		if(birthDate !== ''){
			// this.setState({
			// 	birthDate: ''
			// })
			this.handleSelectDate('');
			datepicker.setOpen(false);
		}		
	}
	renderListAge(){
		let min = 18,
			max = 70,
			list = [];
		for(let i = min; i <= max ;i++){
			list.push(<option value={i} key={i}>{i}</option>);
		}
		return list;
	}	
	render() {
		let { errors, fieldsDefination, sexProps, ageProps, selectAgeProps, advProps, timeAcceptProps, customerNameNote,
			noteProps, birthDateNote, listShopsProp,listRequestItemsProp,listOrdersProp,listSizeProps, shop} = this.props,
			{customerName, fullName, phoneNumber, email, birthDate, age, sex, advSelect, selectAge, 
			minTimeOnWeek, maxTimeOnWeek, minTimeWeekend, maxTimeWeekend, isShowAdvFriend, advFriend, listShops, listRequestItems, listOrders, listSize} = this.state;			
		const labelNote = shop.webStyle === 'YURIKAGO' ? lang.label.label_note_yurikago : lang.label.label_note_sbs
		return (
			<div  >
		<h3 id="bookerInfoTable" className="cor_ttl">{txtLang.label_header_info}</h3>
		<table className="form">
			<tbody>
				<FormItemCom 
					txtLabel = {txtLang.customer_name}
					fieldRequired = {fieldsDefination.displayName}
					nameField = "customerName"
					idField = "displayName"
					value = {customerName}
					typeField="text"
					errorField = {errors.displayName}
					placeholder = "姓　名"
					handleChange = {this.handleChange}
					onKeyUp = {this.handleKeyUp}
					extraTextNote={customerNameNote}
				/>
				<FormItemCom 
					txtLabel = {txtLang.full_name}
					fieldRequired = {fieldsDefination.fullName}
					nameField = "fullName"
					value = {fullName}
					typeField="text"
					errorField = {errors.fullName}
					placeholder = "せい　めい"
					handleChange = {this.handleChange}
					onKeyUp = {this.handleKeyUp}					
				/>
				{
					fieldsDefination.birthDate !== 'HIDDEN' ? 
					<tr>
						<th>{txtLang.birthDate} {fieldsDefination.birthDate === 'REQUIRED' ? <span className="red">{txtLang.label_required}</span> : null }</th>
						<td> 
							<div id="birthDate" className={birthDate !== '' ? ' form__has-clear': ''}>
							<DatePicker
								customInput={<CustomInputDate />}
								selected={birthDate !== '' ? new Date(birthDate) : null}
								openToDate={new Date(birthDate === '' ? new Date('1994/01/01') : birthDate)}
								dateFormat="yyyy/MM/dd"															
								onChange={this.handleSelectDate}
								showMonthDropdown
								showYearDropdown
								dropdownMode="select"
								minDate={new Date('1900/01/01')}
  								maxDate={new Date()}
								placeholderText='1900/01/01'								
								locale='ja'
								ref="datepicker"
							>
							{
								this.state.birthDate !== '' ? <div className="btn-clear-date" onClick={() => this.clearDatePicker()}>クリア</div> : null
							}
							</DatePicker>
							{
								birthDateNote ? <span className="txt-note-bd">※未成年者のお客様は、親権者の同意書が必要となります。</span> : ''
							}
							<ErrorField error={errors.birthDate}/>
							</div>
						</td>
					</tr> : null
				}
				{
					selectAgeProps ? 
					<tr>
						<th>{lang.label.sbsAge} <span className="red">{txtLang.label_required}</span></th>
						<td>
							<select id="fieldSelectAge" name="selectAge" value={selectAge} onChange={e => this.handleChange(e)}>
								<option value="">{txtLang.select_product_placeholder}</option>
								{
									this.renderListAge()
								}
							</select>
							<ErrorField error={errors.fieldSelectAge}/>
						</td>
					</tr> : null
				}
				<FormItemCom 
					txtLabel = {txtLang.phone_number_yuri}
					fieldRequired = {fieldsDefination.phone}
					nameField = "phoneNumber"
					value = {phoneNumber}
					typeField="tel"
					errorField = {errors.phoneNumber}
					placeholder = "000-000-0000"
					handleChange = {this.handleChange}
					onKeyUp = {this.handleKeyUp}
				/>
				<FormItemCom 
					txtLabel = {txtLang.email}
					fieldRequired = {fieldsDefination.email}
					nameField = "email"
					value = {email}
					typeField="email"
					idField="emailAddress"
					errorField = {errors.emailAddress}
					placeholder = "*********@****.com"
					handleChange = {this.handleChange}
					onKeyUp = {this.handleKeyUp}
				/>				
				{
					sexProps ? 
					<tr>
						<th>{lang.label.sex}</th>
						<td>
							<SelectBox name='sex' value={sex} handleChange={this.handleChange} list={listSelectSex}/>
						</td>
					</tr> : null
				}
				{
					ageProps ? 
					<tr>
						<th>{lang.label.age}</th>
						<td>
							<SelectBox name='age' value={age} handleChange={this.handleChange} list={listSelectAge} valueDefault='選択してください'/>
						</td>
					</tr> : null
				}
				{
					timeAcceptProps ?
					<tr>
						<th className="td-label">{lang.label.label_time_accept}<br/><span className="red">{txtLang.label_required}</span></th>
						<td className="td-content">
							<div className="list-select" id="fieldTypeTimeSelect">
								<div className="time-label">平日</div>
								<div className="item item-min">
									<SelectBox name='minTimeOnWeek' value={minTimeOnWeek} handleChange={this.handleChange} list={listMinTimeOnWeek} valueDefault=' '/>
								</div>
								<span className="char">～</span>
								<div className="item item-max">
									<SelectBox name='maxTimeOnWeek' value={maxTimeOnWeek} handleChange={this.handleChange} list={listMaxTimeOnWeek} valueDefault=' '/>
								</div>
							</div>
							<div className="list-select">
								<div className="time-label">土日祝</div>
								<div className="item item-min">
									<SelectBox name='minTimeWeekend' value={minTimeWeekend} handleChange={this.handleChange} list={listMinTimeWeekend} valueDefault=' '/>
								</div>
								<span className="char">～</span>
								<div className="item item-max">
									<SelectBox name='maxTimeWeekend' value={maxTimeWeekend} handleChange={this.handleChange} list={listMaxTimeWeekend} valueDefault=' '/>
								</div>
							</div>
							<ErrorField error={errors.fieldTypeTimeSelect}/>
						</td>
					</tr> : null
				}
				{
					advProps ? 
					<tr>
						<th className="td-label">{lang.label.label_adv_select}<span className="red">{txtLang.label_required}</span></th>
						<td className="td-content">
							<SelectBox 
								id='fieldAdvSelect' 
								name='advSelect' 
								value={advSelect} 
								handleChange={this.handleChangeAdv} 
								list={listSelectAdv} 
								valueDefault='お選びください'
								valueDisabled='【沖縄エリア】'
							/>
							{
								isShowAdvFriend ? 
								<input 
									id="advFriend" 
									value={advFriend} 
									name='advFriend' 
									placeholder = {txtLang.advFriend}
									type='text' 
									className="form_name field-advFriend" 									
									onChange={e => this.handleChange(e)}/> : '' 
							}
							<ErrorField error={errors.fieldAdvSelect}/>
						</td>
					</tr> : null
				}
				{
					listShopsProp ? 
					<tr>
						<th className="td-label">{lang.label.label_list_shops} <span className="red">{txtLang.label_required}</span></th>
						<td>
							<SelectBox name='listShops' value={listShops} handleChange={this.handleChange} list={listSelectShop} valueDefault='ご来店店舗をご選択ください'/>
							<ErrorField error={errors.listShops}/>
						</td>
					</tr>: null
				}
				{
					listRequestItemsProp ? 
					<tr>
						<th className="td-label"><div dangerouslySetInnerHTML={{__html: lang.label.label_list_requests}}></div><span className="red">{txtLang.label_required}</span></th>
						<td>
							<div className="list-request" id="listRequestItems">
								{
									listCheckBoxRequest.map((item, index) => 
										<div className="request-item" key={item}>
											<CheckBox list={listRequestItems} index={index} name={item} value={item} handleChangeCheckBox={this.handleChangeRequest}/>
										</div>	
									)
								}
							</div>
							<ErrorField error={errors.listRequestItems}/>
						</td>
					</tr> : null
				}
				{
					listOrdersProp ?
					<tr>
						<th className="td-label td-label-order">{lang.label.label_list_orders} <span className="red">{txtLang.label_required}</span></th>
						<td>
							<SelectBox name='listOrders' value={listOrders} handleChange={this.handleChange} list={listSelectOrder} valueDefault='ご選択ください'/>
							<ErrorField error={errors.listOrders}/>
						</td>
					</tr> : null
				}
				{
					listSizeProps ? 
					<tr className="content-list-size">
						<th className="td-label"><div dangerouslySetInnerHTML={{__html: lang.label.label_list_size}}></div></th>
						<td>
							<div className="list-size-simizu" id="listSize">
								<div className="size-item">
									<label>身　長</label>
									<input type="text" name="height" value={listSize['height']} onChange={e => this.handleChangeSize(e)} />
									<span>cm</span>
								</div>
								<div className="size-item">
									<label>ウェスト</label>
									<input type="text" min="0" name="width" value={listSize['width']} onChange={e => this.handleChangeSize(e)} />
									<span>cm</span>
								</div>
								<div className="size-item">
									<label>体　重</label>
									<input type="text" min="0" name="weight" value={listSize['weight']} onChange={e => this.handleChangeSize(e)} />
									<span>kg</span>
								</div>
							</div>
						</td>
					</tr> : null
				}
				{
					noteProps ? 
					<tr>
						<th className='bdT1'><div dangerouslySetInnerHTML={{__html: labelNote}}></div></th>
						<td>
							<FormNote />
						</td>
					</tr>: null
				}
			</tbody>
		</table>
	</div>
		)
	}
}
const FormItemCom = ({txtLabel, fieldRequired, value, nameField, typeField, errorField, placeholder, handleChange, idField = '', onKeyUp, extraTextNote = ''}) => {
	return (
		fieldRequired !== 'HIDDEN' ? 
		<tr>
			<th>{txtLabel} {fieldRequired === 'REQUIRED' ? <span className="red">{txtLang.label_required}</span> : null }</th>
			<td> 
				<input onKeyUp={e => onKeyUp(e)} id={idField !== '' ? idField : nameField} value={value} name={nameField} type={typeField} className="form_name" placeholder={placeholder} onChange={e => handleChange(e)}/>
				{
					extraTextNote !== '' && (
						<span className="txt-note-bd">{extraTextNote}</span>
					)
				}
				<ErrorField error={errorField}/>
			</td>
		</tr> : null
	)
}
const CheckBox = (props) => {
	return (
		<Fragment>
			<input checked={props.list.includes(props.value)} id={`checkbox-${props.index}`} type="checkbox" name={props.name} value={props.value} onChange={e => props.handleChangeCheckBox(props.value)} />
			<label htmlFor={`checkbox-${props.index}`}>{props.name}</label>
		</Fragment>
		
	)
}

const SelectBox = (props) => {	
	return (
		<select id={props.id || props.name} name={props.name} value={props.value} onChange={e => props.handleChange(e)}>
			{
				props.valueDefault ? <option value="">{props.valueDefault}</option> : null
			}
			{
				props.list.map(item => <option key={item} disabled={item === props.valueDisabled} value={item}>{item}</option>)
			}
		</select>
	)
}

const ErrorField = ({error}) => {
	return error && error.invalid ? <span className="message-error">{error.message}</span> : ''
}
class CustomInputDate extends Component{
	render() {
		return (
			<button
			  className={`btn-custom-datepicker${this.props.value === '' ? ' placeholder' : ''}`}
			  onClick={this.props.onClick}>
			  {this.props.value === '' ? '1900/01/01' : this.props.value}			  
			</button>
		  )
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(FormInfo);